/**
 * @kidshome/shared — runtime-neutral product constants shared by the API (Node) and the web app
 * (browser). The single source of truth for values that previously drifted as duplicated web↔API
 * copies. Pure values + a derived regex; NO secrets, NO env access, NO framework imports — a true
 * leaf consumed by both runtimes (the API resolves the built `dist/`; web resolves the source).
 */

/**
 * Chore backfill window (days): how far back a guardian may log a missed chore. The server owns the
 * hard bound; the web surfaces the same window for its "log it for that day" affordance.
 * (Distinct from the habit module's own backfill window, which is API-only.)
 */
export const BACKFILL_WINDOW_DAYS = 7;

/**
 * Default ceiling (bytes, = 5 MiB) for a chore photo-proof upload. The API enforces a possibly
 * operator-overridden `PHOTO_PROOF_MAX_BYTES` env value; this is the DEFAULT, mirrored by the web
 * client's pre-upload size check so an oversized photo is rejected kindly before a wasted upload.
 */
export const PHOTO_PROOF_MAX_BYTES_DEFAULT = 5 * 1024 * 1024;

/**
 * The soft cap on live (active + reached) savings goals a child may run at once (ADR-0038). The web
 * hides/disables "New goal" at the cap; the API is the authority and rejects an over-cap create.
 */
export const MAX_LIVE_SAVINGS_GOALS = 5;

/** A child PIN is 4–6 digits. */
export const PIN_MIN_LENGTH = 4;
export const PIN_MAX_LENGTH = 6;

/** Canonical child-PIN format (4–6 digits), derived from {@link PIN_MIN_LENGTH}/{@link PIN_MAX_LENGTH}. */
export const PIN_PATTERN = new RegExp(`^[0-9]{${PIN_MIN_LENGTH},${PIN_MAX_LENGTH}}$`);
